// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AiMessageController from "./ai_message_controller"
application.register("ai-message", AiMessageController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import BillingCalendarController from "./billing_calendar_controller"
application.register("billing-calendar", BillingCalendarController)

import BillingGraphController from "./billing_graph_controller"
application.register("billing-graph", BillingGraphController)

import ChatAutoscrollController from "./chat_autoscroll_controller"
application.register("chat-autoscroll", ChatAutoscrollController)

import ChatFormController from "./chat_form_controller"
application.register("chat-form", ChatFormController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CollapsibleMenuController from "./collapsible_menu_controller"
application.register("collapsible-menu", CollapsibleMenuController)

import DataTableSearchController from "./data_table_search_controller"
application.register("data-table-search", DataTableSearchController)

import DateNavigationController from "./date_navigation_controller"
application.register("date-navigation", DateNavigationController)

import DetailsMemoryController from "./details_memory_controller"
application.register("details-memory", DetailsMemoryController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import EmployeeBillingGraphController from "./employee_billing_graph_controller"
application.register("employee-billing-graph", EmployeeBillingGraphController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HighlightController from "./highlight_controller"
application.register("highlight", HighlightController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PromptModelController from "./prompt_model_controller"
application.register("prompt-model", PromptModelController)

import RowLinkController from "./row_link_controller"
application.register("row-link", RowLinkController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TeamDateSyncController from "./team_date_sync_controller"
application.register("team-date-sync", TeamDateSyncController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import TimeActivitiesViewController from "./time_activities_view_controller"
application.register("time-activities-view", TimeActivitiesViewController)

import TimeActivityModalController from "./time_activity_modal_controller"
application.register("time-activity-modal", TimeActivityModalController)

import TimerController from "./timer_controller"
application.register("timer", TimerController)

import ToolDetailsController from "./tool_details_controller"
application.register("tool-details", ToolDetailsController)

import MarkdownController from "./markdown_controller"
application.register("markdown", MarkdownController)

import DrawerDropdownController from "./drawer_dropdown_controller"
application.register("drawer-dropdown", DrawerDropdownController)
